'use client';

import { useEffect } from 'react';

/**
 * Client component to initialize debugging utilities
 * This should be added to the root layout
 */
export function DebugInitializer() {
    useEffect(() => {
        void import('@/lib/utils/debug-init')
            .then(({ initializeDebug }) => initializeDebug())
            .catch(() => undefined);
    }, []);

    return null;
}

